/** Caropaera War Hero (145) — redeem_ghost.png on triggered Redeem unit */
export const CAROPAERA_REDEEM_GHOST_DURATION_MS = 2000;
